export default __webpack_public_path__ + "media/images/matx-809aa759d9529c2a317a6e184a1dcd25.png";